import React, { type JSX, type ReactNode, type Ref } from "react";
import classNames from "classnames";

interface IProps {
    className: string;
    title: string;
    timestamp?: JSX.Element;
    subtitle?: ReactNode;
    children?: JSX.Element;
    ref?: Ref<HTMLDivElement>;
}

const EventTileBubble = ({ className, title, timestamp, subtitle, children, ref }: IProps): JSX.Element => {
    return (
        <div className={classNames("mx_EventTileBubble", className)} ref={ref}>
            <div className="mx_EventTileBubble_title">{title}</div>
            {subtitle && <div className="mx_EventTileBubble_subtitle">{subtitle}</div>}
            {children}
            {timestamp}
        </div>
    );
};

export default EventTileBubble;
